import {
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  Input,
  OnInit,
} from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { NgxSkeletonLoaderModule } from 'ngx-skeleton-loader';

import { ESvgIcons } from 'src/app/core/enums/svg-icons';
import { AudioTour } from 'src/app/core/types/models/audio-tour';
import { SafeUrlPipe } from 'src/app/shared/pipes/safe-url.pipe';

import { AuthService } from 'src/app/core/services/auth.service';
import { AudioPlayerService } from 'src/app/core/services/audio-player.service';
import { GoogleAnalyticService } from 'src/app/core/services/google-analytic.service';

@Component({
  selector: 'app-voice-guide-card-mobile',
  templateUrl: './voice-guide-card-mobile.component.html',
  styleUrls: ['voice-guide-card-mobile.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [SafeUrlPipe, TranslateModule, NgxSkeletonLoaderModule],
})
export class VoiceGuideCardMobileComponent implements OnInit {
  @Input() tour: AudioTour | null = null;
  @Input() isFetching: boolean = false;
  @Input() countryName: string = '';
  @Input() cityName: string = '';

  protected readonly eSvgIcons = ESvgIcons;

  previewPlaying = false;
  distance = 0;
  itemSettings = {
    type: '',
    icon: '',
    iconSizes: '',
  };

  private settings = {
    cycle: {
      type: 'Cycling Tour',
      icon: 'https://media.voicemap.me/assets/transports/bike-ea198daad3a01bb1d8500f9bd766052d61ea9bc26a5486df30a9dc362049ac03.svg',
      iconSizes: '68px',
    },
    train: {
      type: 'Train Tour',
      icon: 'https://media.voicemap.me/assets/transports/train-64bcc2da64639d00885e9b254234b4a9bc9c1c51f3f7f61722b326ee6cf1fece.svg',
      iconSizes: '57px',
    },
    drive: {
      type: 'Driving Tour',
      icon: 'https://media.voicemap.me/assets/transports/drive-c3dfcfd5e9989adad5e9cc0773d266af7130e6a8c55f9c9dc5e6568784d9f160.svg',
      iconSizes: '67px',
    },
    run: {
      type: 'Running Tour',
      icon: 'https://media.voicemap.me/assets/transports/run-51f79a20d99fb489193fd2ffac9172673d5c5157cdb9b87f4cbefd45ea5191cd.svg',
      iconSizes: '73px',
    },
    boat: {
      type: 'Boat Tour',
      icon: 'https://media.voicemap.me/assets/transports/boat-2f414034db1e3ceebe6c1c77870877da2f35ade7bf1fd738394f13bb41ea4d6e.svg',
      iconSizes: '55px',
    },
    walk: {
      type: 'Walking Tour',
      icon: 'https://media.voicemap.me/assets/transports/walk-d5d98ff316be8984bf698a1fd98ebb34e1e58f371eae8184776a547c3c1c8fd2.svg',
      iconSizes: '71x',
    },
  };

  constructor(
    private googleAnalyticService: GoogleAnalyticService,
    private authService: AuthService,
    private audioPlayerService: AudioPlayerService,
    private cdr: ChangeDetectorRef,
  ) {}

  ngOnInit() {
    if (!this.tour) return;
    this.distance = Math.floor(+this.tour.distance / 1000);

    switch (this.tour.type) {
      case 'Cycle':
        this.itemSettings = this.settings.cycle;
        break;
      case 'Train Tour':
        this.itemSettings = this.settings.train;
        break;
      case 'Drive':
        this.itemSettings = this.settings.drive;
        break;
      case 'Run':
        this.itemSettings = this.settings.run;
        break;
      case 'Boat Ride':
        this.itemSettings = this.settings.boat;
        break;
      case 'Walk':
      default:
        this.itemSettings = this.settings.walk;
    }
  }

  public async tourPreview(e: Event): Promise<void> {
    e.preventDefault();
    e.stopPropagation();

    if (this.previewPlaying) {
      this.audioPlayerService.pause();
    } else {
      await this.audioPlayerService.play(this.tour.clip);
      this.setGoogleAnalytic();
    }

    this.previewPlaying = !this.previewPlaying;
    this.cdr.markForCheck();
  }

  protected setGoogleAnalytic() {
    this.googleAnalyticService.setVoiceMapAnalytic({
      activityName: this.tour.title,
      countryName: this.countryName,
      cityName: this.cityName,
      userID: this.authService.userId,
    });
  }
}
